import React from "react";

const LineRow = ({ heading, text }) => {
  return (
    <div className="d-flex justify-content-start my-2 gap-2 mb-2">
      <p className="m-0 gray-text">{heading}:</p>
      <p className="m-0">{text}</p>
    </div>
  );
};

export default LineRow;
